import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LineChart, Menu, X, ChevronDown } from 'lucide-react';

import { APP_NAME, LOGO_ICON } from '../../constants/appConstants';
import { useAuth } from '../../contexts/AuthContext'; // <-- import the hook
// import { useAppSettings } from '../../contexts/AppSettingsContext';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useAuth(); // get user from context
// const { settings, loading } = useAppSettings();

  console.log(user);

  // Handle navbar transparency on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    // Clean up listener and reset state on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      setIsScrolled(false); 
      setMobileMenuOpen(false);
    };
  }, []);

  // Close mobile menu when navigating
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled || mobileMenuOpen ? 'bg-white shadow-sm' : 'bg-white/90 backdrop-blur-md md:bg-transparent'
    }`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-1" onClick={handleLinkClick}>
            <div className="h-9 w-9 rounded-xl flex items-center justify-center">
              <img src={LOGO_ICON} alt={`${APP_NAME} Logo`} className="h-9 w-9 object-contain" />
            </div>
            <span className="ml-2 text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary-600 to-primary-700">{APP_NAME}</span>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {/* <div className="flex space-x-6 items-center">
              <Link to="/features" className="text-gray-700 hover:text-blue-600 font-medium transition-colors text-sm">Features</Link>
              <Link to="/pricing" className="text-gray-700 hover:text-blue-600 font-medium transition-colors text-sm">Pricing</Link>
              <div className="relative group">
                <button className="flex items-center text-gray-700 hover:text-blue-600 font-medium transition-colors text-sm">
                  Resources <ChevronDown className="ml-1 h-4 w-4" />
                </button>
                <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-right">
                  <div className="py-2 px-3">
                    <Link to="/blog" className="block py-2 text-sm text-gray-700 hover:text-blue-600">Blog</Link>
                    <Link to="/support" className="block py-2 text-sm text-gray-700 hover:text-blue-600">Support</Link>
                    <Link to="/docs" className="block py-2 text-sm text-gray-700 hover:text-blue-600">Documentation</Link>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="flex space-x-3 items-center">

            {/* {!user ? ( */}
                <>
                <Link to="/login" className="text-primary-600 hover:text-primary-700 font-medium transition-colors text-sm">Log in</Link>
                <Link to="/register" className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-2 px-5 rounded-lg hover:shadow-md transition-all font-medium text-sm">
                  Sign up
                </Link>
                </>
              {/* ) :user.isSuperuser ? (
                <Link to="/superadmin/dashboard" className="text-gray-700 hover:text-primary-600 font-medium transition-colors text-sm">Dashboard</Link>
              ):
              (
                <Link to="/dashboard" className="text-gray-700 hover:text-primary-600 font-medium transition-colors text-sm">Dashboard</Link>

              )
              } */}

            </div>
          </div>
          
          {/* Mobile menu button with animation */}
          <button 
            className="md:hidden text-gray-700 relative w-6 h-6" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`absolute block w-6 h-0.5 bg-gray-700 transform transition-all duration-300 ease-in-out ${
              mobileMenuOpen ? 'rotate-45 top-3' : 'top-2'
            }`}></span>
            <span className={`absolute block w-6 h-0.5 bg-gray-700 top-3 transition-all duration-200 ease-in-out ${
              mobileMenuOpen ? 'opacity-0' : 'opacity-100'
            }`}></span>
            <span className={`absolute block w-6 h-0.5 bg-gray-700 transform transition-all duration-300 ease-in-out ${
              mobileMenuOpen ? '-rotate-45 top-3' : 'top-4'
            }`}></span>
          </button>
        </div>
        
        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 mt-2 border-t border-gray-100 bg-white">
            <div className="flex flex-col space-y-3">
              {/* <Link to="/features" className="text-gray-700 font-medium py-2" onClick={handleLinkClick}>Features</Link>
              <Link to="/pricing" className="text-gray-700 font-medium py-2" onClick={handleLinkClick}>Pricing</Link>
              <Link to="/resources" className="text-gray-700 font-medium py-2" onClick={handleLinkClick}>Resources</Link> */}
              {/* <Link to="/login" className="text-blue-600 font-medium py-2" onClick={handleLinkClick}>Log in</Link>
              <Link to="/register" className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 px-4 rounded-lg text-center font-medium mt-2" onClick={handleLinkClick}>
                Sign up
              </Link> */}


              {!user ? (
                <>
                  <Link to="/login" className="text-primary-600 font-medium py-2" onClick={handleLinkClick}>Log in</Link>
                  <Link to="/register" className="bg-gradient-to-r from-primary-600 to-primary-700 text-white py-2 px-4 rounded-lg text-center font-medium mt-2" onClick={handleLinkClick}>
                    Sign up
                  </Link>

                </>
              ) : (
                <Link to="/dashboard" className="text-gray-700 hover:text-primary-600 font-medium transition-colors text-sm">Dashboard</Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;


